import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler";
import { debounce } from "../../../../../../common/snippet/Debouncing";
import { useSelector } from "react-redux";
import { GetProvidersForWorkerInductionReport } from "../../../../../../actions/admin-worker/reports/GetProvidersForWorkerInductionReport";
// import { GetAllProvidersOfWorkerReport } from "../../../../../../actions/admin-worker/reports/GetAllProvidersOfWorkerReport";

function AllProviderMultiSelectDropdown({ title, updateFilter, worker_ids }) {
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [provider_org_ids, setProvider_org_ids] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loadData, setLoadData] = useState(true);
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSeachChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const inputchangeSearch = useCallback(debounce(handleSeachChange), []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleSelect = (item) => {
  //   setCheckData(true);
  //   const newEntry = parseInt(item.provider_org_id, 10);

  //   const exists = provider_org_ids.includes(newEntry);

  //   if (exists) {
  //     setProvider_org_ids(
  //       provider_org_ids.filter((entry) => entry !== newEntry)
  //     );
  //   } else {
  //     setProvider_org_ids([...provider_org_ids, newEntry]);
  //   }
  // };

  const handleSelect = (item) => {
    setCheckData(true);
    const newEntry = {
      worker_id: parseInt(item.worker_id, 10),
      provider_org_id: parseInt(item.provider_org_id, 10),
    };

    const exists = provider_org_ids.some(
      (entry) => entry.provider_org_id === newEntry.provider_org_id
    );

    if (exists) {
      setProvider_org_ids(
        provider_org_ids.filter(
          (entry) => entry.provider_org_id !== newEntry.provider_org_id
        )
      );
    } else {
      setProvider_org_ids([...provider_org_ids, newEntry]);
    }
  };

  const clearSelection = () => {
    setCheckData(true);
    setProvider_org_ids([]);
  };

  useEffect(() => {
    if (checkData) {
      updateFilter(
        "provider_org_ids",
        provider_org_ids.map((item) => item?.provider_org_id)
      );
    }
  }, [provider_org_ids]);
  const GetClientIdData = useCallback(
    async (worker_ids) => {
      if (worker_ids?.length) {
        dispatch(
          GetProvidersForWorkerInductionReport({
            search: searchTerm,
            worker_ids: JSON.stringify(worker_ids),
          })
        ).then((response) => {
          if (response?.success === true) {
            const arrayData = response?.data;
            setItems(
              arrayData?.map((item) => ({
                provider_trading_name: item.provider_trading_name,
                provider_org_id: item.provider_org_id,
              }))
            );
          } else if (response?.status === 401) {
            handleUnauthorizedAccess();
          } else {
            setLoadData(true);
          }
        });
      }

      // eslint-disable-next-line
    },
    [dispatch, searchTerm]
  );

  useEffect(() => {
    GetClientIdData(worker_ids);
    if (worker_ids.length == 0) {
      setProvider_org_ids([]);
    }
  }, [searchTerm, worker_ids?.length]);

  return (
    <div className="relative inline-block text-left w-34" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        disabled={worker_ids?.length > 0 ? false : true}
        type="button"
        className="flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <span>{title}</span>
        {provider_org_ids?.length > 0 && (
          <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
            {provider_org_ids.length}
          </span>
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X provider_org_ids' and Clear button */}
          <div className="flex items-center justify-between p-2 border-b border-gray-200">
            <span className="text-sm text-gray-500">
              {provider_org_ids.length} selected
            </span>
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>

          {/* Search input */}
          <div className="p-2">
            <input
              type="text"
              placeholder="Type here"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              // value={searchTerm}
              onChange={(e) => inputchangeSearch(e)}
            />
          </div>

          {/* Scrollable list of items */}
          <ul className="max-h-48 overflow-y-auto">
            {items?.map((item) => (
              <li
                key={item.organisation_id}
                className="flex items-center px-3 py-2 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  // checked={provider_org_ids?.provider_org_id?.includes(
                  //   parseInt(item.provider_org_id, 10)
                  // )}

                  // checked={provider_org_ids?.includes(
                  //   parseInt(item.provider_org_id, 10)
                  // )}

                  checked={provider_org_ids?.some(
                    (filterItem) =>
                      filterItem.provider_org_id ===
                      parseInt(item.provider_org_id, 10)
                  )}
                  onChange={() => handleSelect(item)}
                />
                <span className="text-sm text-gray-700">
                  {item.provider_trading_name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default AllProviderMultiSelectDropdown;
